import React from "react";
import StatsTickets from "components/ticket/StatsTickets";
import FilesRRHH from "components/documents/FilesRRHH";

import "styles/profile.css";
import { useUserInfo } from "hooks/useUserInfo";
import { useUserStats } from "hooks/useUserStats";
import Loading from "components/load/Loading";

const Profile = () => {
  const { data: user, isLoading: isUserLoading } = useUserInfo();

  const { data: userStats } = useUserStats(user?.id, {
    enabled: !!user?.id,
  });

  if (isUserLoading) {
    return <Loading />;
  }

  return (
    <section className="container-page">
      <p className="title-section-promotions text-center">Mis tickets</p>
      <StatsTickets userTickets={userStats} />
      <FilesRRHH />
    </section>
  );
};

export default Profile;
